module.exports = __webpack_public_path__ + "img/04-3-5banner.12e0dbfb.png";